var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useQuery } from 'react-query';
import { useOkapiKy } from '@folio/stripes/core';
export var useListDetails = function (id, queryOptions) {
    if (queryOptions === void 0) { queryOptions = {}; }
    var ky = useOkapiKy();
    var _a = useQuery(__assign({ queryKey: ['listDetails', id], queryFn: function () { return ky.get("lists/".concat(id)).json(); }, refetchOnWindowFocus: false, retry: false }, queryOptions)), data = _a.data, isLoading = _a.isLoading, refetch = _a.refetch, error = _a.error;
    return {
        refetchDetails: refetch,
        isLoading: isLoading,
        data: data,
        detailsError: error,
    };
};
